<div class="container-fluid d-print-none bg-brand">
    <div class="row">
        <div class="col px-md-8">
            <header class="align-items-center flex-md-nowrap flex-row">
                @if (user$ | async) {
                    <ui-mobile-menu class="me-3" [user]="user$ | async"
                                    [menuItems]="menuItems | async" />
                }

                <ui-logo />

                @if (user$ | async) {
                    <ui-menu-application class="py-1" [menuItems]="menuItems | async" />
                }

                <ui-user-card class="ms-auto" [user]="user$ | async" />

                <ui-lang-checker
                    class="ms-auto ms-lg-5"
                    [selected]="currentLang$ | async"
                    [languages]="languages$ | async"
                    (changeLang)="handlerChangeLang($event)" />
            </header>
        </div>
    </div>
</div>
